import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import "./qrCode";
const QrCodes = ({ sizeOfQR, value }) => {
  const qrRef = useRef();

  return (
    <div className="qrcode__container">
      <div ref={qrRef}>
        <QRCodeCanvas
          id="qrCode"
          value={value}
          size={sizeOfQR}
          bgColor={"#fff"}
          level={"H"}
        />
      </div>
    </div>
  );
};

export default QrCodes;
